// Task #2595 — currencies the platform actually holds a balance in.
//
// USD settles on the US Stripe account; GBP/EUR/DKK/NOK/SEK settle on the
// Intl Stripe account. Cars whose local currency is one of these settle the
// renter's charge in that local currency (full-pay). Cars in any other
// country are partial-pay: the platform fee is charged in USD or EUR (set
// per-country by the admin Countries panel) and the host collects their
// share off-platform in local currency. We never hold or pay out any
// other currency.

export const HOLD_CURRENCIES = [
  "USD",
  "GBP",
  "EUR",
  "DKK",
  "NOK",
  "SEK",
] as const;

export type HoldCurrency = (typeof HOLD_CURRENCIES)[number];

const HOLD_SET = new Set<string>(HOLD_CURRENCIES);

export function isHoldCurrency(code: string | null | undefined): code is HoldCurrency {
  if (!code) return false;
  return HOLD_SET.has(String(code).trim().toUpperCase());
}

/**
 * Partial-pay capture currencies — the only values an admin can set in
 * the Countries panel for a partial-pay country. The full set of admin-
 * configurable charge currencies is constrained to USD or EUR because
 * those are the only two we route into a single hold account regardless
 * of region (USD → US Stripe, EUR → Intl Stripe).
 */
export const PARTIAL_PAY_CAPTURE_CURRENCIES = ["USD", "EUR"] as const;

export type PartialPayCaptureCurrency = (typeof PARTIAL_PAY_CAPTURE_CURRENCIES)[number];

const PARTIAL_PAY_SET = new Set<string>(PARTIAL_PAY_CAPTURE_CURRENCIES);

export function isPartialPayCaptureCurrency(
  code: string | null | undefined,
): code is PartialPayCaptureCurrency {
  if (!code) return false;
  return PARTIAL_PAY_SET.has(String(code).trim().toUpperCase());
}
